import i18next from "i18next";
import { initReactI18next } from "react-i18next";

import bgTranslation from "./bg/translation.json";
import enTranslation from "./en/translation.json";

const resources = {
  bg: {
    translation: bgTranslation,
  },
  en: {
    translation: enTranslation,
  },
};

i18next.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem("language") || "bg",
  interpolation: {
    escapeValue: false,
  },
});